module.exports = __webpack_public_path__ + "static/reward.fd0f7914.png";